module.exports = __webpack_public_path__ + "static/techstack-removebg-009eb14c992a1d38d595d698f9d9bbb7.png";